import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { ProviderGroupControllerApi } from "../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseQuery,
} from "../utils/utils";

interface UseProviderGroupListProps {
  pagination: DGT_Pagination;
  searchKey?: string;
  status?: boolean | undefined;
  archieved?: boolean | undefined;
  gridSorting?: GridSortItem[];
  state?: string | boolean | null;
  xTENANTID?: string;
  enabled?: boolean;
}

/**
 *
 * @author Shrinivas Mandhare
 */

export function useProviderGroupList({
  pagination,
  gridSorting,
  searchKey,
  status,
  state,
  xTENANTID,
  archieved,
  enabled = true,
}: UseProviderGroupListProps): useBaseQuery<any> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "name" : undefined;

  return useQuery({
    queryKey: [
      "provider-group-list",
      pageSize,
      pageIndex,
      status,
      state,
      searchKey,
      gridSorting,
      archieved,
    ],
    enabled: enabled && pagination?.pageSize !== undefined,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new ProviderGroupControllerApi(getConfigObject())
        .getAllProviderGroups(
          pageIndex, //page
          pageSize, //size
          sortBy, // sortBy
          sortDirect, // sortDirection
          status as boolean, //status
          archieved, // archive
          state as string, // state
          undefined, //speciality
          searchKey,
          xTENANTID
        )
        .then((it) => it?.data?.data),
  });
}
